const SCREEN_BREAKPOINTS = {
    xs: 320,
    sm: 600,
    md: 900,
    lg: 1160,
    xl: 1760,
};

export default SCREEN_BREAKPOINTS;
